import apiClient from 'utilities/apiClient';

// get_Countrycodes
export const get_Countrycodes = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// occupation_Data
export const occupation_Data = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// get_MStatus
export const get_MStatus = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

//  get_FamilyStatus
export const get_FamilyStatus = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// get_FamilyValue
export const get_FamilyValue = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// get_FamilyType
export const get_FamilyType = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// aboutme_page;
export const aboutme_page = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.aboutme_page}`,
    payload,
    true,
    'file'
  );
};

export const detailsList = (payload) => {
  return apiClient.get(`${apiClient.Urls.listView}/${payload}`, payload, true);
};

// delete_profileimg
export const delete_profileimg = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.createdetails}/${url}`,
    payload,
    true
  );
};
// export const aboutme_page = (payload) => {
//   return apiClient.patch(
//     `${apiClient.Urls.aboutme_page}`,
//     payload, // FormData is passed here
//     { headers: { 'Content-Type': 'multipart/form-data' } } // Ensure correct headers
//   );
// };
